module.exports = __webpack_public_path__ + "static/bacp-fb42e7d4360022ebe70857cefa81531f.png";